import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { LinkList } from '../../components/Footer/LinkList.js';
import { RollupItem } from '../../components/RollupItem/RollupItem.js';
export const Sitemap = JSX(({ navigationItems }) => (_jsx("div", { className: "w-full", role: "menu", children: renderTopItems(navigationItems) })));
const renderTopItems = (topItems) => topItems
    ?.filter((_) => _.icon?.icon)
    .map((item, i) => (_jsx(RollupItem, { foldButtonVersion: "accordion", label: item?.text, labelIcon: item?.icon, role: "menuitem", children: item.items ? _jsx(LinkList, { items: item.items }) : null }, String(i))));
//# sourceMappingURL=Sitemap.js.map